
import Button from "../Button";
// import { usePagePopup } from "../PopupPage";
import styled from "styled-components";
import ContentBox from "../ContentBox";
import { useNavigate } from "react-router-dom";

import Stepper from "../Stepper/index2";
import Animation from "../Animation";
import { recoilStates } from "src/recoil/recoilStates";
import { useRecoilState } from "recoil";
import { IoMailUnreadOutline } from "react-icons/io5";
export default function HasProposal() {
  const [bookingApplication] = useRecoilState(recoilStates.eventApplication);

  // 신청 직후 1, 조건제시 3, 클럽거절7
  const acceptedClubs = bookingApplication?.event_booking_rel_club?.filter((c) =>
    [3].includes(c?.status_id || 0)
  );

  const rejectedRels = bookingApplication?.event_booking_rel_club?.filter(
    (cr) => cr.status_id === 2
  );
  const reviewingRels = bookingApplication?.event_booking_rel_club?.filter(
    (cr) => cr.status_id === 1
  );

  const navigate = useNavigate();

  return (
    <>
      <Container className="d-flex fd-c gap-2">
        <Stepper
          className="page-pd-negative-side page-pd-negative-top"
          currentIdx={1}
          stepsXpadding={"70px"}
          title="조건 검토 후 확정하세요~"
          steps={[
            { label: "부킹 신청", icon: "booking-register" },
            { label: "조건 협의", icon: "select-club" },
            { label: "부킹 확정", icon: "confirm-club" },
            // {
            //   label: (
            //     <div className="d-flex fd-c ai-c">
            //       <div>보증금</div>
            //       <div>확인</div>
            //     </div>
            //   ),
            //   icon: "money",
            // },
            // { label: "멤버 등록", icon: "invite-member" },
          ]}
        />
        <div className="ani-box d-flex jc-c ai-c">
          <Animation jsonFetchPath={`${process.env.PUBLIC_URL}/selection.json`} loop={false} />
        </div>
        <ContentBox
          className=""
          colorTheme="gray"
          onClick={() => {
            navigate("/event-booking/proposals");
            // openBookingProposalPagePopup();
          }}
          content={
            <div className="d-flex fd-c gap-2 jc-c ai-c pt-2">
              {acceptedClubs?.map((c) => {
                return (
                  <div key={`accept-msg-${bookingApplication?.id}-${c.club_id}`} className="">
                    <p className="fs-4 d-flex ai-c gap-1">
                      <IoMailUnreadOutline fontSize={20} className="mr-x" />{" "}
                      <span className="bold"> {c.club?.name}</span> 부킹조건 도착!
                    </p>
                  </div>
                );
              })}
              <div className="d-flex fd-c gap-1 ai-c">
                {rejectedRels?.map((rr) => {
                  return (
                    <div key={`rr-${rr.id}`}>
                      <span className="bold">{rr.club?.name}</span> 거절도착 !
                    </div>
                  );
                })}
              </div>
              <div className="d-flex fd-c gap-1 ai-c">
                {reviewingRels?.map((rr) => {
                  return (
                    <div key={`rr-${rr.id}`}>
                      <span className="bold">{rr.club?.name}</span> 검토중...
                    </div>
                  );
                })}
              </div>

              {/* <p className="date">접수일시: {bookingApplication?.created_at}</p> */}
              <div className="as-str d-flex fd-c mt-4 as-str">
                <Button $colorTheme="green" className="bold" $buttonSize="md" $round>
                  보러가기
                </Button>
              </div>
            </div>
          }
        ></ContentBox>
      </Container>
    </>
  );
}

const Container = styled.div`
  .ani-box {
    > div {
      max-width: 250px;
    }
    min-width: 1px;
  }
`;

const ReqContent = styled.div`
  overflow: auto;
  .img-box {
    padding: 5px;
    img {
      width: 100%;
    }
  }
`;
